import {AuthRoutes} from '../modules/auth/Auth.routes';

export const Routes = {
  auth: {...AuthRoutes},
};
